import { API } from "@swivl-mono/api-helper";
import { BrandInterface } from "@swivl-mono/types";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";

interface StoreInterface {
  brands?: { [brandId: number]: BrandInterface };
}

const BlankState: StoreInterface = {
  brands: undefined,
};

export default class BrandsModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = BrandsModel.useState.setState;
  static get state() {
    return BrandsModel.useState.getState();
  }
  static reset() {
    BrandsModel.setState({ ...BlankState });
  }

  static async load(force: boolean) {
    if (!force && BrandsModel.state.brands) return;
    API.Brands.getBrands(Member.orgId!).then((brands) => {
      BrandsModel.setState({
        brands: brands
          .sort((a, b) => a.name.localeCompare(b.name))
          .reduce(
            (acc, brand) => {
              acc[brand.id] = brand;
              return acc;
            },
            {} as { [brandId: number]: BrandInterface },
          ),
      });
    });
  }
  static updateBrand(brand: BrandInterface) {
    let brands = { ...BrandsModel.state.brands };
    if (!brands) return;
    if (!brand.avatarURL) {
      brand.avatarURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/avatar-default-org.png";
    }

    brands[brand.id] = brand;
    BrandsModel.setState({ brands: brands });
    API.Brands.updateBrand(Member.orgId!, brand).then((updated) => {});
  }

  static create() {
    return API.Brands.createBrand(Member.orgId!, { name: "New Brand" }).then((brand) => {
      let brands = { ...BrandsModel.state.brands };
      if (!brands) return;
      brands[brand.id] = brand;
      BrandsModel.setState({ brands: brands });
    });
  }

  static async getIsBrandSlugUnique(brandId: number, newBrandSlug?: string, newShortLink?: string) {
    return await API.Spot.isBrandSlugUnique(Member.orgId!, brandId, newBrandSlug, newShortLink)
      .then(({ isInOrg, isUnique }) => {
        if (isUnique) {
          return true;
        } else {
          return false;
        }
      })
      .catch(() => {
        return false;
      });
  }

  static deleteBrand(brandId: number) {
    return API.Brands.deleteBrand(Member.orgId!, brandId).then(() => {
      let brands = { ...BrandsModel.state.brands };
      if (!brands) return;
      delete brands[brandId];
      BrandsModel.setState({ brands: brands });
    });
  }
}
